/**
 * Hook to get the appropriate API client based on whether we're in bootstrap mode
 *
 * Bootstrap mode uses adminApiClient (admin username/password auth)
 * Normal mode uses apiClient (SSO auth)
 */

import { useLocation } from 'react-router-dom';
import { apiClient } from '@/services/api';
import { adminApiClient } from '@/services/adminApi';

export function useAdminApi() {
  const location = useLocation();

  // Check if we're in bootstrap mode (path starts with /admin-setup/dashboard)
  const isBootstrapMode = location.pathname.startsWith('/admin-setup/dashboard');

  // Return the appropriate API client
  return isBootstrapMode ? adminApiClient : apiClient;
}

export function useIsBootstrapMode() {
  const location = useLocation();
  return location.pathname.startsWith('/admin-setup/dashboard');
}
